import React from "react";
import FlightTimeDisplay from "../../../../../../components/DateTimeDisplay/FlightTimeDisplay";
import { formatSignedDurationDelta } from "../timetable/previewDiffDisplay";

const isStdColumn = (columnKey) => columnKey === "stdTime" || columnKey === "std";

const FlightTimeCellRenderer = ({ row, column }) => {
    const rawFlight = row.rawFlight || {};
    const isStd = isStdColumn(column.key);
    const utcTime = isStd ? rawFlight.std : rawFlight.sta;
    const airportCode = isStd ? row.departureAirport || rawFlight.departure_airport : row.arrivalAirport || rawFlight.arrival_airport;
    const previewField = isStd ? "std" : "sta";
    const previewDiff = row.previewDiffs?.[previewField];

    if (row._previewRole === "after" && previewDiff) {
        const stdDiff = row.previewDiffs?.std;
        const afterBaseTime = isStd ? null : stdDiff?.after ?? rawFlight.std;
        const deltaLabel = formatSignedDurationDelta(previewDiff.deltaMinutes);

        return (
            <div className="schedule-draft-rdg-time-cell schedule-draft-rdg-time-cell-preview-diff">
                <span className="schedule-draft-rdg-preview-diff-main">
                    <FlightTimeDisplay utcTime={previewDiff.after ?? utcTime} airportCode={airportCode} baseUtcTime={afterBaseTime} stdTime={afterBaseTime} disableDetail />
                </span>
                {deltaLabel ? <span className="schedule-draft-rdg-preview-diff-delta">{deltaLabel}</span> : null}
            </div>
        );
    }

    return (
        <div className="schedule-draft-rdg-time-cell">
            <FlightTimeDisplay utcTime={utcTime} airportCode={airportCode} baseUtcTime={isStd ? null : rawFlight.std} stdTime={isStd ? null : rawFlight.std} disableDetail />
        </div>
    );
};

export default FlightTimeCellRenderer;
